export default "__VITE_ASSET__e03b117d__"